import { render, staticRenderFns } from "./TrainingsUsersEdit.vue?vue&type=template&id=3220d350&scoped=true"
import script from "./TrainingsUsersEdit.vue?vue&type=script&lang=js"
export * from "./TrainingsUsersEdit.vue?vue&type=script&lang=js"
import style0 from "./TrainingsUsersEdit.vue?vue&type=style&index=0&id=3220d350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220d350",
  null
  
)

export default component.exports